import {
  GetAccessTokenUseCase,
  GET_ACCESS_TOKEN_USE_CASE,
  IAuthenticationRepository,
  SignOutForAppUseCase,
  SIGN_OUT_USE_CASE,
  AUTHENTICATION_REPOSITORY,
} from '@module/user';

export const authenticationUseCaseProviders = [
  {
    provide: SIGN_OUT_USE_CASE,
    useFactory: (authenticationRepository: IAuthenticationRepository) => {
      return new SignOutForAppUseCase(authenticationRepository);
    },
    inject: [AUTHENTICATION_REPOSITORY],
  },
  {
    provide: GET_ACCESS_TOKEN_USE_CASE,
    useFactory: (authenticationRepository: IAuthenticationRepository) => {
      return new GetAccessTokenUseCase(authenticationRepository);
    },
    inject: [AUTHENTICATION_REPOSITORY],
  },
];
